import { CardsService } from 'src/app/shared/services/cards.service';
import { CacaoService } from 'src/app/shared/services/cacao.service';
import { Card } from './../../../shared/models/cards';
import { UsersService } from 'src/app/shared/services/users.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { userInfo } from 'os';
import { User } from 'src/app/shared/models/users';
import notify from 'devextreme/ui/notify';


@Component({
  selector: 'app-users-detail',
  templateUrl: './users-detail.component.html',
  styleUrls: ['./users-detail.component.scss']
})
export class UsersDetailComponent implements OnInit {
  public uid: string;
  public user: User;
  public card: Card;

  public tabs = [];
  public tabIndex = 0;
  public filters: any;
  public popup = {
    updateEmail: false
  }
  
  constructor(
    private usuarios_Service: UsersService,
    private cacao_service: CacaoService,
    private card_service: CardsService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.tabs.push({name: 'info',  label: 'Datos Personales', route: ''});
    //this.tabs.push({name: 'company',  label: 'Empresa', route: ''});
    //if(this.user.programs[0].card || this.user.programs[0].cards.length > 0) 
    //this.tabs.push({name: 'cards',  label: 'Tarjetas', route: ''});
    this.tabs.push({name: 'dispersions',  label: 'Dispersiones', route: ''});
    this.tabs.push({name: 'movements',  label: 'Movimientos', route: ''});

    this.filters = {
      dateStart: new Date(),
      dateEnd: new Date()
    }
  }

  ngOnInit() {
    this.uid = this.router.url.split('?')[0].split('/').pop();
    console.log(this.uid);
    this.getUser();
  }

  getUser() {
    this.usuarios_Service.getUser({id: this.uid}).toPromise()
    .then((result: any) => {
      console.log(result);
      this.user = result.user;
      console.log(this.user);
      this.card = result.user.program[0].card;
      if(this.card) {
        this.getBalanceCard();
      }
      console.log(this.user);
      console.log(this.card);
    }).
    catch(error => {
      console.log(error);
    })
  }
  getBalanceCard() {
    this.cacao_service.ConsultarTarjeta(this.card.cardNumber).toPromise()
    .then((result: any) => {
      console.log(result);
      this.card.balance = result.data.SaldoActual[0].Saldo;
    })
    .catch(error => console.log(error));
  }
  onTabChange(e,index) {
    this.tabIndex = index;
  }
  updateEmail() {      
    this.usuarios_Service.updateEmail(this.user.id, this.user.email).toPromise()
    .then(res => {
      if(res.error) {
        notify(res.error.message, 'danger', 1000);
      } else {
        notify('Se ha actualizado con éxito el Email, y se envio un correo electronico con la información para iniciar sesión', 'success', 1000);
      }
    })
    .catch(error => {
      console.log('ERROR');
      console.log(error);
    });
  }

  sendEmailBienvenida() {      
    this.usuarios_Service.sendEmailBienvenida([this.user.email]).toPromise()
    .then(res => {
      if(res.error) {
        notify(res.error.message, 'danger', 1000);
      } else {
        notify('Se ha enviado un correo electronico con la información para iniciar sesión', 'success', 1000);
      }
    })
    .catch(error => {
      console.log('ERROR');
      console.log(error);
    });
  }
  cardActivate(_cardNumber) {
    this.card_service.activate(this.user.id, this.user.programs[0],_cardNumber).toPromise()
    .then((res: any) => {
      if(res.error) {
        notify(res.error.message, 'danger', 1000);
      } else {
        notify('Se ha enviado un correo electronico con la información para iniciar sesión', 'success', 1000);
      }
    })
    .catch(error => {
      console.log('ERROR');
      console.log(error);
    });
  }
  /*get tabIndex() {
    let _route = this.router.url.split('?')[0].split('/').pop();
    return this.tabs.indexOf(this.tabs.find(t => t.route == _route));
  }*/

  openClosePopup(_popup,_status) {
    switch(_popup) {
      case 'update_email': this.popup.updateEmail = _status;
    }
  }
  onClosePopup(e,_popup) {
    console.log(e);
    switch(_popup) {
      case 'update_email': 
        this.user.email = e.data ? e.data.email : this.user.email;
        this.popup.updateEmail = false;
        break;
    }
  }

}
